<ul
    role="menu"
    class="
    fc-dropdown-menu
    fc-dropdown-menu-{{ typeName }}
    fc-dropdown-menu-direction-{{ dropdownDirection }}"
    data-e2e-hook="dropdown-menu-download"
>
    <ng-content></ng-content>
</ul>
